<template>
  <div class="item-box-430">
    <div class="default-page">
      <img :src="emptyIcon" />
      <p>{{ warningStr }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emptyIcon: require('@assets/img/empty2@2x.png'),
      tableType: this.$route.meta.tableType,
      portOrg: Number(localStorage.getItem('portOrg'))
    }
  },
  computed: {
    warningStr() {
      let str = ''
      switch (Number(this.tableType)) {
        case 1:
          str = ''
          break;
        case 2:
          str = '请选择学校,机构开户银行，点击查询'
          break;
        case 3:
          str = '请选择教育局，点击查询'
          break;
      }
      return str
    }
  },
  created() {

  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
.default-page {
  text-align: center;
  padding: 16px 0;
  img {
    margin-bottom: 32px;
  }
  p {
    font-weight: bold;
    font-size: 20px;
  }
}
</style>